<template>
  <Onboarding />
</template>

<script>
import { Onboarding } from "../../components/templates"
export default {
  components: {
    Onboarding
  },
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
</style>